import type { TokenStore } from "@/domains/tokens/token-store"
import { ETH } from "@/domains/tokens/static-tokens"

/**
 * Returns the native token (ETH) as a TokenStore instance
 * This is a static token that doesn't change, so we return it directly
 *
 * @returns TokenStore instance for the native token (ETH)
 */
export const useNativeTokenStore = (): TokenStore => {
  return ETH
}
